import {BaseEntity} from "../common/base-entity";

export class MatterDocument extends BaseEntity {
    id: number;
    documentName: string;
    description: string;
    lastUpdatedTimeStamp: string;
}
